import { theme } from '@global-engineering-shared/gweb-material-theme-next';

import { ButtonOverrides } from './Button';

const overrides = {
  ...theme.overrides,
  MuiButton: ButtonOverrides,
};

export default overrides;
